// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';
import DataLayerEventNames from '../constants/DataLayer/EventNames';

export default class ClearFilters extends Component {
  #clickHandler: function;

  /**
   * Initialize a new component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.#clickHandler = this.handleClick.bind(this);
    pEl.addEventListener(EventNames.CLICK, this.#clickHandler);
  }

  /**
   * Triggered when the user clicks on the component element
   */
  handleClick(): void {
    window.store.url.clearFilters();

    this.dispatch({
      event: DataLayerEventNames.FILTER_CLEAR,
      GA4: true
    });

    this.notify(Notifications.FILTER);
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    document.removeEventListener(EventNames.CLICK, this.#clickHandler);
    super.destroy();
  }
}
